import { useEffect } from 'react';

import { components, GroupBase, MenuListProps } from 'react-select';

import classNames from 'classnames';

import { useVirtual } from 'components/select/virtual/hooks';

import cssClasses from './virtual-menu-list.module.scss';

function VirtualMenuList<Option, IsMulti extends boolean, Group extends GroupBase<Option>>({
  children,
  className,
  innerRef: _,
  ...props
}: MenuListProps<Option, IsMulti, Group>) {
  const { focusedOption } = props;
  const { currentIndex, flattenedChildren, items, measureRef, parentRef, scrollTo, totalSize } = useVirtual({
    children,
    options: props.options,
  });

  useEffect(() => {
    scrollTo(currentIndex(focusedOption));
  }, [currentIndex, focusedOption, scrollTo]);

  return (
    <components.MenuList
      className={classNames(className, cssClasses.virtualMenuList)}
      innerRef={parentRef}
      {...props}>
      <div
        className={cssClasses.virtualMenuWrapper}
        style={{ height: totalSize }}>
        <div
          className={cssClasses.virtualOptionWrapper}
          style={{ transform: `translateY(${items[0]?.start ?? 0}px)` }}>
          {items.map((virtualRow) => {
            return (
              <div
                data-index={virtualRow.index}
                key={virtualRow.index}
                ref={measureRef}>
                {flattenedChildren[virtualRow.index]}
              </div>
            );
          })}
        </div>
      </div>
    </components.MenuList>
  );
}

export default VirtualMenuList;
